import { monthsToShemitah } from "@/lib/cycleData";
import { useInView } from "@/hooks/useInView";
import { cn } from "@/lib/utils";

export function CycleStats({ className }: { className?: string }) {
  const { ref, inView } = useInView<HTMLDivElement>(0.15);
  const months = monthsToShemitah();

  const boxes = [
    { value: String(months), label: "months to window" },
    { value: "Sep 2028", label: "Shemitah begins" },
    { value: "Y3–4", label: "current position" },
  ];

  return (
    <div ref={ref} className={cn("grid grid-cols-1 sm:grid-cols-3 gap-3", className)}>
      {boxes.map((b, i) => (
        <div
          key={b.label}
          className={cn(
            "rounded-lg border border-border/60 bg-card px-4 py-3 text-center sm:text-left",
            inView ? "cycle-fade-up" : "opacity-0"
          )}
          style={{ animationDelay: `${i * 100}ms` }}
        >
          <div className="font-plex text-xl font-bold text-foreground">{b.value}</div>
          <div className="text-[11px] text-muted-foreground mt-0.5">{b.label}</div>
        </div>
      ))}
    </div>
  );
}

export default CycleStats;
